// ToDo[major]: add exact routes for not staging env
import React from 'react';
import { SwitchTransition, CSSTransition } from 'react-transition-group';
import { Switch, Redirect, Route, useLocation } from 'react-router-dom';

import AuthScreen from '../../screens/AuthScreen';
import RecoveryPasswordScreen from '../../screens/RecoveryPasswordScreen';
import UpdatePasswordScreen from '../../screens/UpdatePasswordScreen';
import SsoScreen from '../../screens/SsoScreen/SsoScreen';
import parentPaths from '../paths';

import './routes.scss';

const GuestRoutes = () => {
  const { pathname } = useLocation();

  return (
    <SwitchTransition mode="out-in">
      <CSSTransition
        key={pathname}
        classNames="fade"
        addEndListener={(node, done) => node.addEventListener('transitionend', done, false)}
      >
        <Switch>
          <Route
            path={parentPaths.recoverPassword}
            component={RecoveryPasswordScreen}
          />

          <Route
            path={parentPaths.updatePassword}
            component={UpdatePasswordScreen}
          />

          <Route
            path={parentPaths.default}
            exact
            component={AuthScreen}
          />

          <Route
            path={parentPaths.sso}
            exact
            component={SsoScreen}
          />

          <Redirect
            to={{
              pathname: parentPaths.default,
              state: { referrer: pathname },
            }}
          />
        </Switch>
      </CSSTransition>
    </SwitchTransition>
  );
};

export default GuestRoutes;
